<template>
  <div id="treemap">
    <svg width="100%" height="400"></svg>
  </div>
</template>
<script>
import * as d3 from "d3";
import chartModule from "@/services/dcbox.js";

export default {
  name: "Treemap",
  props: {},
  data() {
    return {
      sexualIdentity: this.$store.state.options.sexualIdentity,
      colors: this.$store.state.chartColors,
      labels: [],
      dataset: {}
    };
  },
  computed: {
    reports: function() {
      return this.$store.state.filteredReports;
    },
    chartSelection: function() {
      return this.$store.state.chartSelection;
    }
  },
  watch: {
    reports: function() {
      this.draw();
    }
  },
  methods: {
    drawTreemap() {
      const svg = d3.select("#treemap svg");
      const width = svg.style("width").replace("px", "");
      const height = +svg.attr("height");
      const fader = function(color) {
        return d3.interpolateRgb(color, "#fff")(0.2);
      };
      const domain = this.sexualIdentity;
      const color = d3.scaleOrdinal(d3.schemeDark2); //.range(d3.schemeDark2).domain(domain);//d3.scaleOrdinal(d3.schemeBlues[9].map(fader));
      const format = d3.format(",d");
      const treemap = d3
        .treemap()
        .tile(d3.treemapResquarify)
        .size([width, height])
        .round(true)
        .paddingInner(1);
      const data = this.dataset;
      const root = d3
        .hierarchy(data)
        .eachBefore(function(d) {
          d.data.id = (d.parent ? d.parent.data.id + "." : "") + d.data.name;
        })
        .sum(sumBySize)
        .sort(function(a, b) {
          return b.height - a.height || b.value - a.value;
        });

      treemap(root);

      const cell = svg
        .selectAll("g")
        .data(root.leaves())
        .enter()
        .append("g")
        .attr("transform", function(d) {
          return "translate(" + d.x0 + "," + d.y0 + ")";
        });

      cell
        .append("rect")
        .attr("id", function(d) {
          return d.data.id;
        })
        .attr("width", function(d) {
          return d.x1 - d.x0;
        })
        .attr("height", function(d) {
          return d.y1 - d.y0;
        })
        .attr("fill", (d, i) => {
          console.log(color(i), "color");
          return color(i);
        }) //this.identityTypes.filter(type => type.title === d.parent.data.name)[0].color )
        .style("stroke", "white");

      cell
        .append("clipPath")
        .attr("id", function(d) {
          return "clip-" + d.data.id;
        })
        .append("use")
        .attr("xlink:href", function(d) {
          return "#" + d.data.id;
        });

      cell
        .append("text")
        .attr("clip-path", function(d) {
          return "url(#clip-" + d.data.id + ")";
        })
        .selectAll("tspan")
        .data(function(d) {
          console.log(d, "d");
          return [d.data.name, d.data.size];
        })
        .enter()
        .append("tspan")
        .attr("x", 4)
        .attr("y", function(d, i) {
          return 13 + i * 13;
        })
        .text(function(d) {
          return d;
        })
        .style("fill", "white")
        .style("font", "bold 15px Rajdhani, sans-serif");

      cell.append("title").text(function(d) {
        return d.data.id + "\n" + format(d.value);
      });

      d3.selectAll("input")
        .data([sumBySize, sumByCount], function(d) {
          return d ? d.name : this.value;
        })
        .on("change", changed);

      const timeout = d3.timeout(function() {
        d3.select('input[value="sumByCount"]')
          .property("checked", true)
          .dispatch("change");
      }, 2000);

      function changed(sum) {
        timeout.stop();

        treemap(root.sum(sum));

        cell
          .transition()
          .duration(750)
          .attr("transform", function(d) {
            return "translate(" + d.x0 + "," + d.y0 + ")";
          })
          .select("rect")
          .attr("width", function(d) {
            return d.x1 - d.x0;
          })
          .attr("height", function(d) {
            return d.y1 - d.y0;
          });
      }

      function sumByCount(d) {
        return d.children ? 0 : 1;
      }

      function sumBySize(d) {
        return d.size;
      }
    },
    draw() {
      const svg = d3.select("#treemap svg");
      const width = svg.style("width").replace("px", "");
      const height = +svg.attr("height");
      const config = {
        size: {
          width: width,
          height: height,
          margin: {
            left: 30,
            right: 10,
            top: 10,
            bottom: 30
          }
        },
        xAxis: {
          enabled: false
        },
        yAxis: {
          enabled: false
        }
      };

      var treemap = chartModule
        .config(config)
        .bindTo("#treemap svg")
        .data({ raw: this.reports })
        .layer("treemap")
        .colors(this.colors);

      treemap.nestBy([this.chartSelection]).labels(true);

      chartModule.draw();
    }
  },
  mounted() {
    this.draw();
  }
};
</script>

<style></style>
